const configuredRouteBase = import.meta.env.VITE_DOCS_ROUTE_BASE_PATH?.trim();

function normalizeRouteBase(value: string | undefined) {
  const routeBase = value || '/documents';
  return `/${routeBase.replace(/^\/+|\/+$/g, '')}`;
}

// Vite's BASE_URL points at the CDN in DEV/PRO builds. Page routing must stay
// on the PosBI origin so API requests and authentication cookies remain same-origin.
export const docsBasePath = normalizeRouteBase(configuredRouteBase);

export type DocsRoute =
  | { type: 'home' }
  | { type: 'login' }
  | {
      type: 'document';
      documentId: string;
      revisionId?: string;
      targetBlockId?: string;
    }
  | { type: 'not-found' };

export function docsPath(path = '') {
  const normalized = path ? `/${path.replace(/^\//, '')}` : '';
  return `${docsBasePath}${normalized}`;
}

function decodeHash(value: string) {
  if (!value) return undefined;
  try {
    return decodeURIComponent(value);
  } catch {
    return undefined;
  }
}

export function parseRoute(): DocsRoute {
  const pathname = window.location.pathname.replace(/\/$/, '');
  if (pathname === docsBasePath) return { type: 'home' };
  if (pathname === `${docsBasePath}/login`) {
    return { type: 'login' };
  }
  if (pathname.startsWith(`${docsBasePath}/`)) {
    let documentId = '';
    try {
      documentId = decodeURIComponent(pathname.slice(docsBasePath.length + 1));
    } catch {
      return { type: 'not-found' };
    }
    if (documentId && !documentId.includes('/')) {
      const query = new URLSearchParams(window.location.search);
      return {
        type: 'document',
        documentId,
        revisionId: query.get('revisionId') || undefined,
        targetBlockId: decodeHash(window.location.hash.slice(1)),
      };
    }
  }
  return { type: 'not-found' };
}
